import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { getTalentosThunk } from "../store/reducers/talentos/talentos.thunks";
import TalentosHeader from "./talentos/TalentosHeader";
import TalentosTable from "./talentos/TalentosTable";
import TalentoViewModal from "./talentos/TalentoViewModal";
import ConfirmToggleModal from "./talentos/ConfirmToggleModal";
import TalentoFormModal from "./talentos/TalentoFormModal";
import Loader from "./UI/Loader";
import Alert from "./UI/Alert";
import Pagination from "./UI/Pagination";
import {
  clearTalentosError,
  setPage,
} from "../store/reducers/talentos/talentos.reducer";

const TalentosListLayer = () => {
  const dispatch = useDispatch();
  const {
    list,
    loading,
    error,
    page,
    next,
    previous,
    maxPageReached,
    search,
    count,
  } = useSelector((state) => state.talentos);

  useEffect(() => {
    dispatch(getTalentosThunk({ page, search }));
  }, [dispatch, page, search]);

  const handlePageChange = (newPage) => {
    dispatch(setPage(newPage));
  };

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <TalentosHeader />

        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearTalentosError())}
          />
        )}

        {loading ? (
          <Loader center text="Cargando talentos..." delay={200} />
        ) : (
          <>
            {search && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {count > 0 ? (
                    <>
                      Se {count === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{count}</strong>{" "}
                      {count === 1 ? "resultado" : "resultados"} para "{search}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{search}"</>
                  )}
                </span>
              </div>
            )}

            <TalentosTable talentos={list} search={search} />

            {count > 0 && (
              <Pagination
                page={page}
                count={count}
                pageSize={10}
                onPageChange={handlePageChange}
              />
            )}
          </>
        )}
      </div>

      {/* Modales */}
      <TalentoViewModal />
      <TalentoFormModal />
      <ConfirmToggleModal />
    </div>
  );
};

export default TalentosListLayer;
